import { http } from "./http";
import {
  RecommendProductsRequest,
  RecommendProductsResponse,
  RecommendedProduct,
  StorefrontProductsResponse,
} from "@/types/api/product";

export async function recommendProducts(req: RecommendProductsRequest): Promise<RecommendProductsResponse[]> {
  return http.post<RecommendProductsResponse[]>("/api/product/recommend", req);
}

export async function findAllProductsByIds(ids: number[]): Promise<RecommendedProduct[]> {
  return http.get<RecommendedProduct[]>(`/api/product/many-by-ids?ids=${ids.join(",")}`);
}

export async function getStorefrontProducts(): Promise<StorefrontProductsResponse> {
  return http.get<StorefrontProductsResponse>("/api/product/storefront");
}
